import { useQuery, useQueryClient } from "@tanstack/react-query";
import { StringifiableRecord } from "query-string";

import { ExecuteData, useApi } from "../../useApi";

import { IUseGetServicesProps } from "./useGetServices.types";

import { useAuth } from "@/core/libs/use-auth";
import { useSelectedBu } from "@/hooks/useSelectedBu";

const SERVICES_QUERY_TOKEN = "services";

export const useGetServices = ({
  params,
  urlString,
  method
}: IUseGetServicesProps) => {
  const { execute } = useApi();
  const { isAuthenticated } = useAuth();
  const queryClient = useQueryClient();

  const { selectedBU } = useSelectedBu();

  const paramValues = {
    businessActionId: selectedBU?.id,
    all: true,
    page: 1,
    ...params
  };

  const fetchData = async (params: StringifiableRecord) => {
    const data: ExecuteData = {
      url: urlString || "admin/services",
      method: method || "GET",
      notificationMessage: "Buscando Benefícios prestados",
      params: params
    };

    if (data.method !== "GET") {
      data.bodyObj = params;
    }

    return execute(data);
  };

  const { data, isFetching } = useQuery({
    queryKey: [SERVICES_QUERY_TOKEN, paramValues],
    queryFn: () => fetchData(paramValues),
    enabled: isAuthenticated,
    staleTime: 120000,
    placeholderData: prev => prev
  });

  const invalidateQuery = () => {
    queryClient.invalidateQueries({ queryKey: [SERVICES_QUERY_TOKEN] });
  };

  return {
    servicesList: data?.data,
    isLoadingServicesList: isFetching,
    invalidateQuery
  };
};
